import Vue from "vue";
import { registerMicroApps, loadMicroApp, prefetchApps, initGlobalState } from "qiankun";
import store from "@/store";
export {
  // 注册微应用
  registerMicroApps,
  // 设置主应用启动后默认进入的子应用
  setDefaultMountApp,
  // 手动加载一个微应用
  loadMicroApp,
  prefetchApps,
  // 定义全局状态，并返回通信方法，建议在主应用使用，微应用通过 props 获取通信 方法
  initGlobalState,
  // 启动 qiankun
  start
} from "qiankun";

// 主应用与微应用数据通信
const state = {
  hiddenSidebar: true,
  loaded: false,
  updateUserInfo: false, // 是否需要更新用户信息
  subviewBreadcrumb: [], // 子应用路径
  hiddenBreadcrumb: true,
  subappClassName: "" // 设置子应用打包根的class类名
};
const actions = initGlobalState(state);

actions.setGlobalState(state);

actions.onGlobalStateChange((state, prev) => {
  const { hiddenSidebar, loaded, updateUserInfo, subviewBreadcrumb = [], hiddenBreadcrumb = true, subappClassName } = state;
  // 设置左侧菜单显示隐藏

  store.dispatch("setSidebarDisplayStatus", hiddenSidebar);
  // 设置子应用路由matched
  store.dispatch("setSubviewBreadcrumb", subviewBreadcrumb);
  // 设置子应用面包屑是否显示
  store.dispatch("setHiddenSubviewBreadcrumb", hiddenBreadcrumb);
  // 存储子应用加载完成状态
  store.dispatch("setMountAppLoaded", loaded);
  // 如果需要更新用户信息
  if (updateUserInfo) {
    store.dispatch("UpdateUserInfo", { reload: true });
  }
  store.dispatch("setSubappClassName", subappClassName);
});
export { actions };

// 本地子应用开发地址
const subAppLocalhost = {
  // 登录/注册‐基础应用
  signMountApp: "//localhost:8001",
  // 运营管理
  operation: "//localhost:8102",
  // 数字身份‐子应用
  didadmin: "//localhost:8302"
};

/**
 * 获取本地应用服务开发地址
 * @param  {String} appCode 服务code
 * @return {String} 返回服务本地开发地址
 **/
export function serviceLocalhost(appCode) {
  if (subAppLocalhost[appCode]) {
    return subAppLocalhost[appCode];
  } else {
    return "";
  }
}

/** 注册微应用
 * @param {Object} Apps 微应用注册信息
 * @param {Object} props 传递的数据
 */
export function registerSubApps({ loadMicro, name, container = "#subview", activeRule } = {}, props = {}) {
  props.websiteConfig = store.getters.websiteConfig; // 网站配置
  props.itrus = Vue.prototype.$itrus; // 通用插件
  props.currentUser = store.getters.currentUser; // 当前身份权限信息
  props.qiankunContainer = container.slice(1); // 子服务挂载容器名
  props.personalInfo = store.getters.personalInfo; // 当前账号个人信息
  props.rootDir = process.env.PROJECT_ROOT; // 部署路径 saas '/home'文件夹，front'/'默认根路径

  const entry = appEntry(name); // 微应用的入口

  // 手动加载微应用
  if (loadMicro) {
    let configuration = {};

    if (!Vue.prototype.$ie11) {
      configuration = {
        sandbox: { experimentalStyleIsolation: false, strictStyleIsolation: false }
      };
    }
    return loadMicroApp(
      {
        name,
        entry,
        container, // 微应用的容器节点的选择器或者 Element 实例
        props
      },
      configuration
    );
  }

  // 自动加载微应用
  const microApps = [];
  const microApp = {
    name,
    entry,
    container, // 微应用的容器节点的选择器或者 Element 实例
    activeRule: process.env.PROJECT_ROOT + (activeRule || `#/subview/${name}`) // 微应用的激活规则
  };

  microApp.props = props; // 通信数据
  microApps.push(microApp);

  // 注册子应用
  registerMicroApps(microApps, {
    beforeLoad: [
      (app) => {
        console.log("[LifeCycle] before load %c%s", "color: green;", app.name);
      }
    ],
    beforeMount: [
      (app) => {
        console.log("[LifeCycle] before mount %c%s", "color: green;", app.name);
      }
    ],
    afterUnmount: [
      (app) => {
        console.log("[LifeCycle] after unmount %c%s", "color: green;", app.name);
      }
    ]
  });
}

/** 获取微应用的入口地址
 * @param  { String } name 微应用名称
 * @return { String } 返回微应用入口地址
 */
export function appEntry(name) {
  return process.env.NODE_ENV == "development" ? serviceLocalhost(name) : `/${name}/`; // 微应用的入口
}

/** 预加载微应用列表
 * @param  { Array | String } appNameArr ['app1','app2'] || 'app1'
 * @return { Array } 返回预加载微应用列表
 *
 */
export function getPrefetchAppsList(appNameArr) {
  if (typeof appNameArr === "string") {
    return [{ name: appNameArr, entry: appEntry(appNameArr) }];
  }
  return appNameArr.reduce((pre, appName) => {
    pre.push({ name: appName, entry: appEntry(appName) });
    return pre;
  }, []);
}



// WEBPACK FOOTER //
// ./src/qiankun/index.js